export default {
  title: 'Exchange Statistics',
  exchangeTime: 'Exchange Time',
  startDate: 'Start Date',
  endDate: 'End Date',
  totalPointsConsumed: 'Total Points Consumed',
  totalGiftsExchanged: 'Total Gifts Exchanged',
  unitGifts: '件',
  totalOrders: 'Total Orders',
  unitOrders: '单',
  popularRankTitle: 'Popular Gift Ranking',
  rankNo: 'Rank',
  giftDetail: 'Gift Detail',
  exchangeQty: 'Quantity',
  popularity: 'Share',
  trendTitle: 'Last 7 Days Exchange',
  trendSeries: 'Quantity',
  rangeLimitTip: 'Up to 1 year. Data below updates with the filter.',
};
